const fullRoutes: string[] = [
  '/:visit',
  '/admin/sign-in:visit',
  '/funder/sign-in:visit',
  '/institution/sign-in:visit',
  '/service-provider/sign-in:visit',
  '/forgot-password:visit',
  'activity-session:approve',

  '/institution:visit',
  '/institution/my-profile:visit',
  '/institution/notifications:visit',
  '/institution/insights:visit',
  '/institution/insights/:insightType/:insightId:visit',

  '/institution/reports:visit',
  '/institution/reports/requirements:visit',
  // '/institution/reports/create:visit',
  '/institution/reports/create-link:visit',
  '/institution/reports/create-report:visit',
  '/institution/reports/:reportId:visit',

  '/institution/reports/templates:visit',
  '/institution/reports/create-template:visit',
  '/institution/reports/templates/:templateId:visit',

  '/institution/programmes/portfolios:visit',
  '/institution/programmes/:programmeId/sites:visit',
  '/institution/programmes/:programmeId/sites/hierarchies:visit',
  '/institution/programmes/:programmeId/sites/hierarchies/:hierarchyId:visit',
  '/institution/programmes/:programmeId/sites/hierarchies/create:visit',
  '/institution/programmes/:programmeId/sites/services:visit',
  '/institution/programmes/:programmeId/sites/services/:serviceId:visit',
  '/institution/programmes/:programmeId/sites/services/create:visit',
  '/institution/programmes/:programmeId/reporters:visit',
  '/institution/programmes/:programmeId/reporters/:reporterId/assignees:visit',
  '/institution/programmes:visit',
  '/institution/programmes/create:visit',
  '/institution/programmes/:programmeId/overview:visit',
  '/institution/programmes/:programmeId/indicators:visit',
  '/institution/programmes/:programmeId/monitoring:visit',
  '/institution/programmes/:programmeId/complete:visit',
  '/institution/programmes/interventions:visit',
  '/institution/programmes/interventions/create:visit',
  '/institution/programmes/interventions/:interventionId/stakeholders:visit',
  '/institution/programmes/interventions/:interventionId/stakeholders/cohorts:visit',
  '/institution/programmes/interventions/:interventionId/stakeholders/cohorts/create:visit',
  '/institution/programmes/interventions/:interventionId/stakeholders/cohorts/:cohortId:visit',
  '/institution/programmes/interventions/:interventionId/institutions:visit',
  '/institution/programmes/interventions/:interventionId/institutions/cohorts:visit',
  '/institution/programmes/interventions/:interventionId/institutions/cohorts/create:visit',
  '/institution/programmes/interventions/:interventionId/institutions/cohorts/:cohortId:visit',
  '/institution/programmes/interventions/:interventionId/overview:visit',
  '/institution/programmes/interventions/:interventionId/indicators:visit',
  '/institution/programmes/interventions/:interventionId/inputs:visit',
  '/institution/programmes/interventions/:interventionId/activities:visit',
  '/institution/programmes/interventions/:interventionId/monitoring:visit',
  '/institution/programmes/interventions/:interventionId/complete:visit',
  '/institution/programmes/interventions/:interventionId/reporters:visit',
  '/institution/programmes/interventions/:interventionId/reporters/:reporterId/assignees:visit',

  '/institution/exports:visit',
  '/institution/exports/:workspaceId/questions:visit',
  '/institution/exports/:workspaceId/questions/:type/:typeId:visit',
  '/institution/exports/profile-data:visit',
  '/institution/exports/programme-stats:visit',
  '/institution/exports/school-data:visit',

  '/institution/manage:visit',
  '/institution/manage/institutions:visit',
  '/institution/manage/institutions/sites:visit',
  '/institution/manage/institutions/sites/hierarchies:visit',
  '/institution/manage/institutions/sites/hierarchies/:hierarchyId:visit',
  '/institution/manage/institutions/sites/hierarchies/create:visit',
  '/institution/manage/institutions/sites/services:visit',
  '/institution/manage/institutions/sites/services/:serviceId:visit',
  '/institution/manage/institutions/sites/services/create:visit',
  '/institution/manage/institutions/archived:visit',
  '/institution/manage/institutions/create:visit',
  '/institution/manage/institutions/:institutionId:visit',
  '/institution/manage/institutions/:institutionId/service-details:visit',
  '/institution/manage/institutions/:institutionId/service-contacts:visit',
  '/institution/manage/institutions/:institutionId/registration-management:visit',
  '/institution/manage/institutions/:institutionId/registrations:visit',
  '/institution/manage/institutions/:institutionId/registrations/register:visit',
  '/institution/manage/institutions/:institutionId/registrations/:ecdRegistrationId/application:visit',
  '/institution/manage/institutions/:institutionId/registrations/:ecdRegistrationId/framework:visit',
  '/institution/manage/institutions/:institutionId/registrations/:ecdRegistrationId/assessment:visit',
  '/institution/manage/institutions/:institutionId/registrations/:ecdRegistrationId/complete:visit',
  '/institution/manage/institutions/:institutionId/registrations/:ecdRegistrationId/approve:visit',
  '/institution/manage/institutions/:institutionId/people:visit',
  '/institution/manage/institutions/:institutionId/people/create:visit',
  '/institution/manage/people:visit',
  '/institution/manage/people/create:visit',
  '/institution/manage/people/:personId:visit',
  '/institution/manage/institutions/:institutionId/people/:personId:visit',
  '/institution/manage/people/addnew:visit',
  '/institution/manage/people/cohorts:visit',
  '/institution/manage/people/cohorts/create:visit',
  '/institution/manage/people/cohorts/:cohortId:visit',

  '/institution/my-activities:visit',
  '/institution/my-activities/:activityId/sessions/:visit',
  '/institution/my-activities/:activityId/sessions/create:visit',
  '/institution/my-activities/:activityId/sessions/:sessionId:visit',
  '/institution/my-activities/:activityId/attendees/:visit',
  '/institution/activities/activity/:activityId:visit',

  '/institution/manage/cases:visit',
  '/institution/manage/cases/:caseId:visit',
  '/institution/manage/cases/consultations:visit',
  '/institution/manage/cases/consultations/:consultationId:visit',
  '/institution/manage/cases/case-management:visit',
  '/institution/manage/cases/case-management/activities/:activityId/configure:visit',
  '/institution/manage/cases/case-management/case-id-configuration:visit',
  '/institution/manage/cases/case-management/case-details-configuration:visit',
  '/institution/manage/cases/case-management/case-summary-configuration:visit',
  '/institution/manage/cases/appointments:visit',
  '/institution/manage/cases/medication-queue:visit',

  '/institution/my-forms:visit',
  '/institution/my-forms/:id/:date/capture:visit',
  '/institution/my-forms/:id/submissions:visit',
  '/institution/my-forms/:id/submissions/:submissionId:visit',
  '/institution/my-forms/:id/submissions/submit:visit',

  '/institution/my-forms:visit',
  '/institution/forms/new-forms:visit',
  '/institution/forms/previously-submitted-forms:visit',

  `/institution/team-members:visit`,
  `/institution/team-members/create-new:visit`,
  `/institution/team-members/:teamMemberId:visit`,
  '/institution/team-members/:teamMemberId/activities:visit',
  '/institution/team-members/:stakeholderId/activities:visit',
  `/institution/team-members/:stakeholderId/activities/:activityId/sessions:visit`,
  `/institution/team-members/:stakeholderId/activities/:activityId/sessions/create:visit`,
  `/institution/team-members/:stakeholderId/activities/:activityId/sessions/:sessionId:visit`,
  '/institution/activities/activity/:activityId:visit',
  '/institution/activities/:stakeholderId:edit',

  '/institution/manage/admin:visit',
  '/institution/manage/admin/create-new:visit',
  '/institution/admin/workspaces:visit',
  '/institution/admin/workspaces/create-new:visit',
  '/institution/admin/workspaces/:workspaceId:visit',
  '/institution/admin/workspaces/:workspaceId/overview:visit',
  '/institution/admin/workspaces/:workspaceId/overview/datasets/create-new:visit',
  '/institution/admin/workspaces/:workspaceId/overview/datasets/:datasetId:visit',
  '/institution/admin/workspaces/:workspaceId/overview/forms/create-new:visit',
  '/institution/admin/templates:visit',
  '/institution/admin/workspaces/:workspaceId/overview/forms/:formId:visit',

  '/institution/manage/workspaces:visit',
  '/institution/manage/workspaces/create-new:visit',
  '/institution/manage/workspaces/:workspaceId:visit',
  '/institution/manage/workspaces/:workspaceId/overview:visit',
  '/institution/manage/workspaces/:workspaceId/overview/datasets/create-new:visit',
  '/institution/manage/workspaces/:workspaceId/overview/datasets/:datasetId:visit',
  '/institution/manage/workspaces/:workspaceId/overview/forms/create-new:visit',
  '/institution/manage/workspaces/:workspaceId/overview/forms/:formId:visit',

  '/institution/admin/modules:visit',
  '/institution/admin/audittrail:visit',
  '/institution/manage/insights:visit',
  '/institution/manage/insights/create-new:visit',
  '/institution/manage/insights/:insightId:visit',
  '/institution/manage/insights/:insightId/users:visit',
  '/institution/admin/organisations:visit',
  '/institution/admin/organisations/:organisationId/users:visit',

  '/institution/manage/activities:visit',
  '/institution/manage/activities/:activityId/sessions/:visit',
  '/institution/manage/activities/:activityId/sessions/create:visit',
  '/institution/manage/activities/:activityId/sessions/:sessionId:visit',
  '/institution/manage/activities/:activityId/attendees/:visit',
  '/institution/manage/activities/:activityId:visit',
  '/institution/manage/activities/create:visit',
  '/institution/manage/activities/activity/:activityId:visit',
  '/institution/manage/activities/:activityId/assign-users:visit',
  '/institution/manage/groups:visit',
  '/institution/manage/groups/:groupId/options:visit',
  '/institution/manage/services:visit',
  '/institution/manage/services/:serviceId:visit',
  '/institution/manage/services/create:visit',

  '/institution/manage/indicatorFrameworks:visit',
  '/institution/manage/indicatorFrameworks/:indicatorFrameworkId/indicators:visit',
  '/institution/manage/indicatorFrameworks/:indicatorFrameworkId/indicators/:indicatorId:visit',
  '/institution/manage/indicatorFrameworks/:indicatorFrameworkId/indicators/:indicatorId/periods:visit',
  '/institution/manage/indicatorFrameworks/:indicatorFrameworkId/monitoring:visit',
  '/institution/manage/indicatorFrameworks/:indicatorFrameworkId/reporters:visit',
  '/institution/manage/indicatorFrameworks/:indicatorFrameworkId/reporters/:reporterId/assignees:visit',

  '/institution/manage/indicatorFrameworks/period-groups:visit',
  '/institution/manage/indicatorFrameworks/period-groups/:periodGroupId/periods:visit',

  '/institution/interventions/period-groups:visit',
  '/institution/programmes/period-groups:visit',
  '/institution/programmes/period-groups/:periodGroupId/periods:visit',
  '/institution/interventions/period-groups/:periodGroupId/periods:visit',

  '/institution/manage/indicatorFrameworks/currency-groups:visit',
  '/institution/manage/indicatorFrameworks/currency-groups/:currencyGroupId/periods:visit',
  '/institution/interventions/currency-groups/:currencyGroupId/periods:visit',
  '/institution/programmes/currency-groups/:currencyGroupId/periods:visit',
  '/institution/interventions/currency-groups:visit',
  '/institution/programmes/currency-groups:visit',

  '/institution/team-members/:stakeholderId/activities:visit',
  '/institution/team-members/:stakeholderId/activities/:activityId/sessions:visit',
  '/institution/team-members/:stakeholderId/activities/:activityId/sessions/:sessionId:visit',
  '/institution/team-members/:stakeholderId/activities/:activityId/sessions/create:visit',
  '/institution/team-members/:stakeholderId/activities/:activityId/attendees:visit',
];

const freeViewerRoutes: string[] = [
  '/:visit',
  '/admin/sign-in:visit',
  '/funder/sign-in:visit',
  '/institution/sign-in:visit',
  '/service-provider/sign-in:visit',
  '/forgot-password:visit',

  '/institution:visit',
  '/institution/my-profile:visit',
  '/institution/notifications:visit',
  '/institution/insights:visit',
  '/institution/insights/:insightType/:insightId:visit',

  '/institution/my-forms:visit',

  `/institution/team-members:visit`,
];

const freeExplorerRoutes: string[] = [
  '/:visit',
  '/admin/sign-in:visit',
  '/funder/sign-in:visit',
  '/institution/sign-in:visit',
  '/service-provider/sign-in:visit',
  '/forgot-password:visit',

  '/institution:visit',
  '/institution/my-profile:visit',
  '/institution/notifications:visit',
  '/institution/insights:visit',
  '/institution/insights/:insightType/:insightId:visit',

  '/institution/manage:visit',
  '/institution/manage/institutions:visit',
  '/institution/manage/institutions/sites:visit',
  '/institution/manage/institutions/sites/hierarchies:visit',
  '/institution/manage/institutions/sites/hierarchies/:hierarchyId:visit',
  '/institution/manage/institutions/sites/hierarchies/create:visit',
  '/institution/manage/institutions/sites/services:visit',
  '/institution/manage/institutions/sites/services/:serviceId:visit',
  '/institution/manage/institutions/sites/services/create:visit',
  '/institution/manage/institutions/archived:visit',
  '/institution/manage/institutions/create:visit',
  '/institution/manage/institutions/:institutionId:visit',
  '/institution/manage/institutions/:institutionId/service-details:visit',
  '/institution/manage/institutions/:institutionId/people:visit',
  '/institution/manage/institutions/:institutionId/people/create:visit',
  '/institution/manage/institutions/:institutionId/service-contacts:visit',
  '/institution/manage/institutions/:institutionId/registration-management:visit',
  '/institution/manage/people:visit',
  '/institution/manage/people/create:visit',
  '/institution/manage/people/:personId:visit',
  '/institution/manage/institutions/:institutionId/people/:personId:visit',
  '/institution/manage/people/addnew:visit',
  '/institution/manage/people/cohorts:visit',
  '/institution/manage/people/cohorts/create:visit',
  '/institution/manage/people/cohorts/:cohortId:visit',

  '/institution/programmes/portfolios:visit',
  '/institution/programmes/:programmeId/sites:visit',
  '/institution/programmes/:programmeId/sites/hierarchies:visit',
  '/institution/programmes/:programmeId/sites/hierarchies/:hierarchyId:visit',
  '/institution/programmes/:programmeId/sites/hierarchies/create:visit',
  '/institution/programmes/:programmeId/sites/services:visit',
  '/institution/programmes/:programmeId/sites/services/:serviceId:visit',
  '/institution/programmes/:programmeId/sites/services/create:visit',
  '/institution/programmes/:programmeId/reporters:visit',
  '/institution/programmes/:programmeId/reporters/:reporterId/assignees:visit',
  '/institution/programmes:visit',
  '/institution/programmes/create:visit',
  '/institution/programmes/:programmeId/overview:visit',
  '/institution/programmes/:programmeId/indicators:visit',
  '/institution/programmes/:programmeId/monitoring:visit',
  '/institution/programmes/:programmeId/complete:visit',
  '/institution/programmes/interventions:visit',
  '/institution/programmes/interventions/create:visit',
  '/institution/programmes/interventions/:interventionId/stakeholders:visit',
  '/institution/programmes/interventions/:interventionId/stakeholders/cohorts:visit',
  '/institution/programmes/interventions/:interventionId/stakeholders/cohorts/create:visit',
  '/institution/programmes/interventions/:interventionId/stakeholders/cohorts/:cohortId:visit',
  '/institution/programmes/interventions/:interventionId/institutions:visit',
  '/institution/programmes/interventions/:interventionId/institutions/cohorts:visit',
  '/institution/programmes/interventions/:interventionId/institutions/cohorts/create:visit',
  '/institution/programmes/interventions/:interventionId/institutions/cohorts/:cohortId:visit',
  '/institution/programmes/interventions/:interventionId/overview:visit',
  '/institution/programmes/interventions/:interventionId/indicators:visit',
  '/institution/programmes/interventions/:interventionId/inputs:visit',
  '/institution/programmes/interventions/:interventionId/activities:visit',
  '/institution/programmes/interventions/:interventionId/monitoring:visit',
  '/institution/programmes/interventions/:interventionId/complete:visit',
  '/institution/programmes/interventions/:interventionId/reporters:visit',
  '/institution/programmes/interventions/:interventionId/reporters/:reporterId/assignees:visit',

  '/institution/my-forms:visit',

  `/institution/team-members:visit`,
];

const fullGuestRoutes: string[] = [
  '/:visit',
  '/admin/sign-in:visit',
  '/funder/sign-in:visit',
  '/institution/sign-in:visit',
  '/service-provider/sign-in:visit',
  '/forgot-password:visit',

  '/institution:visit',
  '/institution/my-profile:visit',
  '/institution/notifications:visit',
  '/institution/insights:visit',
  '/institution/insights/:insightType/:insightId:visit',

  '/institution/reports:visit',
  '/institution/reports/requirements:visit',
  // '/institution/reports/create:visit',
  '/institution/reports/create-link:visit',
  '/institution/reports/create-report:visit',
  '/institution/reports/:reportId:visit',
  '/institution/reports/templates:visit',
  '/institution/reports/create-template:visit',
  '/institution/reports/templates/:templateId:visit',
];

export const INSTITUTION_OWNER_PLANS = {
  FREE_VIEWER: {
    static: [
      ...freeViewerRoutes,
      '/institution/admin:visit',
      '/institution/manage/reporting-requirements:visit',
      '/institution/manage/reporting-requirements/:requirementId:visit',
      '/institution/manage/dashboards:visit',
      '/institution/manage/dashboards/layout/create-new:visit',
      '/institution/manage/dashboards/layout/:layoutId:visit',
      '/institution/manage/dashboards/workspace/:workspaceId:visit',
    ],
  },
  FREE_EXPLORER: {
    static: [
      ...freeExplorerRoutes,
      '/institution/admin:visit',
      '/institution/manage/reporting-requirements:visit',
      '/institution/manage/reporting-requirements/:requirementId:visit',
      '/institution/manage/dashboards:visit',
      '/institution/manage/dashboards/layout/create-new:visit',
      '/institution/manage/dashboards/layout/:layoutId:visit',
      '/institution/manage/dashboards/workspace/:workspaceId:visit',
    ],
  },
  STANDARD: {
    static: [
      ...fullRoutes,
      '/institution/manage/dashboards:visit',
      '/institution/manage/dashboards/layout/create-new:visit',
      '/institution/manage/dashboards/layout/:layoutId:visit',
      '/institution/manage/dashboards/workspace/:workspaceId:visit',
      '/institution/manage/dashboards/workspace/:workspaceId/:dashboardId:visit',
      '/institution/manage/dashboards/workspace/:workspaceId/:dashboardId/users:visit',
      '/institution/manage/dashboards/metabase:visit',
      '/institution/manage/dashboards/metabase/:type/:id:visit',
      '/institution/manage/templates:visit',
      '/institution/manage/templates/create-new:visit',
      '/institution/manage/templates/:templateId:visit',
      '/institution/admin:visit',
      '/institution/manage/reporting-requirements:visit',
      '/institution/manage/reporting-requirements/:requirementId:visit',
    ],
  },
  PREMIUM: {
    static: [
      ...fullRoutes,
      '/institution/manage/dashboards:visit',
      '/institution/manage/dashboards/layout/create-new:visit',
      '/institution/manage/dashboards/layout/:layoutId:visit',
      '/institution/manage/dashboards/workspace/:workspaceId:visit',
      '/institution/manage/dashboards/workspace/:workspaceId/:dashboardId:visit',
      '/institution/manage/dashboards/workspace/:workspaceId/:dashboardId/users:visit',
      '/institution/manage/dashboards/metabase:visit',
      '/institution/manage/dashboards/metabase/:type/:id:visit',
      '/institution/manage/templates:visit',
      '/institution/manage/templates/create-new:visit',
      '/institution/manage/templates/:templateId:visit',
      '/institution/admin:visit',
      '/institution/manage/reporting-requirements:visit',
      '/institution/manage/reporting-requirements/:requirementId:visit',
    ],
  },
  ENTERPRISE: {
    static: [
      ...fullRoutes,
      '/institution/manage/dashboards:visit',
      '/institution/manage/dashboards/layout/create-new:visit',
      '/institution/manage/dashboards/layout/:layoutId:visit',
      '/institution/manage/dashboards/workspace/:workspaceId:visit',
      '/institution/manage/dashboards/workspace/:workspaceId/:dashboardId:visit',
      '/institution/manage/dashboards/workspace/:workspaceId/:dashboardId/users:visit',
      '/institution/manage/dashboards/metabase:visit',
      '/institution/manage/dashboards/metabase/:type/:id:visit',
      '/institution/manage/templates:visit',
      '/institution/manage/templates/create-new:visit',
      '/institution/manage/templates/:templateId:visit',
      '/institution/admin:visit',
      '/institution/manage/reporting-requirements:visit',
      '/institution/manage/reporting-requirements/:requirementId:visit',
    ],
  },
  BUSINESS: {
    static: [
      ...fullRoutes,
      '/institution/manage/dashboards:visit',
      '/institution/manage/dashboards/layout/create-new:visit',
      '/institution/manage/dashboards/layout/:layoutId:visit',
      '/institution/manage/dashboards/workspace/:workspaceId:visit',
      '/institution/manage/dashboards/workspace/:workspaceId/:dashboardId:visit',
      '/institution/manage/dashboards/workspace/:workspaceId/:dashboardId/users:visit',
      '/institution/manage/dashboards/metabase:visit',
      '/institution/manage/dashboards/metabase/:type/:id:visit',
      '/institution/manage/templates:visit',
      '/institution/manage/templates/create-new:visit',
      '/institution/manage/templates/:templateId:visit',
      '/institution/admin:visit',
      '/institution/manage/reporting-requirements:visit',
      '/institution/manage/reporting-requirements/:requirementId:visit',
    ],
  },
};

export const INSTITUTION_ADMIN_PLANS = {
  FREE_VIEWER: {
    static: [
      ...freeViewerRoutes,
      '/institution/admin:visit',
      '/institution/manage/reporting-requirements:visit',
      '/institution/manage/reporting-requirements/:requirementId:visit',
      '/institution/manage/dashboards:visit',
      '/institution/manage/dashboards/layout/create-new:visit',
      '/institution/manage/dashboards/layout/:layoutId:visit',
      '/institution/manage/dashboards/workspace/:workspaceId:visit',
    ],
  },
  FREE_EXPLORER: {
    static: [
      ...freeExplorerRoutes,
      '/institution/admin:visit',
      '/institution/manage/reporting-requirements:visit',
      '/institution/manage/reporting-requirements/:requirementId:visit',
      '/institution/manage/dashboards:visit',
      '/institution/manage/dashboards/layout/create-new:visit',
      '/institution/manage/dashboards/layout/:layoutId:visit',
      '/institution/manage/dashboards/workspace/:workspaceId:visit',
    ],
  },
  STANDARD: {
    static: [
      ...fullRoutes,
      '/institution/manage/dashboards:visit',
      '/institution/manage/dashboards/layout/create-new:visit',
      '/institution/manage/dashboards/layout/:layoutId:visit',
      '/institution/manage/dashboards/workspace/:workspaceId:visit',
      '/institution/manage/dashboards/workspace/:workspaceId/:dashboardId:visit',
      '/institution/manage/dashboards/workspace/:workspaceId/:dashboardId/users:visit',
      '/institution/manage/dashboards/metabase:visit',
      '/institution/manage/dashboards/metabase/:type/:id:visit',
      '/institution/manage/templates:visit',
      '/institution/manage/templates/create-new:visit',
      '/institution/manage/templates/:templateId:visit',
      '/institution/admin:visit',
      '/institution/manage/reporting-requirements:visit',
      '/institution/manage/reporting-requirements/:requirementId:visit',
    ],
  },
  PREMIUM: {
    static: [
      ...fullRoutes,
      '/institution/manage/dashboards:visit',
      '/institution/manage/dashboards/layout/create-new:visit',
      '/institution/manage/dashboards/layout/:layoutId:visit',
      '/institution/manage/dashboards/workspace/:workspaceId:visit',
      '/institution/manage/dashboards/workspace/:workspaceId/:dashboardId:visit',
      '/institution/manage/dashboards/workspace/:workspaceId/:dashboardId/users:visit',
      '/institution/manage/dashboards/metabase:visit',
      '/institution/manage/dashboards/metabase/:type/:id:visit',
      '/institution/manage/templates:visit',
      '/institution/manage/templates/create-new:visit',
      '/institution/manage/templates/:templateId:visit',
      '/institution/admin:visit',
      '/institution/manage/reporting-requirements:visit',
      '/institution/manage/reporting-requirements/:requirementId:visit',
    ],
  },
  ENTERPRISE: {
    static: [
      ...fullRoutes,
      '/institution/manage/dashboards:visit',
      '/institution/manage/dashboards/layout/create-new:visit',
      '/institution/manage/dashboards/layout/:layoutId:visit',
      '/institution/manage/dashboards/workspace/:workspaceId:visit',
      '/institution/manage/dashboards/workspace/:workspaceId/:dashboardId:visit',
      '/institution/manage/dashboards/workspace/:workspaceId/:dashboardId/users:visit',
      '/institution/manage/dashboards/metabase:visit',
      '/institution/manage/dashboards/metabase/:type/:id:visit',
      '/institution/manage/templates:visit',
      '/institution/manage/templates/create-new:visit',
      '/institution/manage/templates/:templateId:visit',
      '/institution/admin:visit',
      '/institution/manage/reporting-requirements:visit',
      '/institution/manage/reporting-requirements/:requirementId:visit',
    ],
  },
  BUSINESS: {
    static: [
      ...fullRoutes,
      '/institution/manage/dashboards:visit',
      '/institution/manage/dashboards/layout/create-new:visit',
      '/institution/manage/dashboards/layout/:layoutId:visit',
      '/institution/manage/dashboards/workspace/:workspaceId:visit',
      '/institution/manage/dashboards/workspace/:workspaceId/:dashboardId:visit',
      '/institution/manage/dashboards/workspace/:workspaceId/:dashboardId/users:visit',
      '/institution/manage/dashboards/metabase:visit',
      '/institution/manage/dashboards/metabase/:type/:id:visit',
      '/institution/manage/templates:visit',
      '/institution/manage/templates/create-new:visit',
      '/institution/manage/templates/:templateId:visit',
      '/institution/admin:visit',
      '/institution/manage/reporting-requirements:visit',
      '/institution/manage/reporting-requirements/:requirementId:visit',
    ],
  },
};

export const INSTITUTION_MEMBER_PLANS = {
  FREE_VIEWER: {
    static: freeViewerRoutes,
  },
  FREE_EXPLORER: {
    static: freeExplorerRoutes,
  },
  STANDARD: {
    static: fullRoutes,
  },
  PREMIUM: {
    static: fullRoutes,
  },
  ENTERPRISE: {
    static: fullRoutes,
  },
  BUSINESS: {
    static: fullRoutes,
  },
};

export const INSTITUTION_FIELD_MEMBER_PLANS = {
  FREE_VIEWER: {
    static: freeViewerRoutes,
  },
  FREE_EXPLORER: {
    static: freeExplorerRoutes,
  },
  STANDARD: {
    static: [
      ...freeExplorerRoutes,
      '/institution/reports:visit',
      '/institution/reports/requirements:visit',
      //  '/institution/reports/create:visit',
      '/institution/reports/create-link:visit',
      '/institution/reports/create-report:visit',
      '/institution/reports/:reportId:visit',
      '/institution/reports/templates:visit',
      '/institution/reports/create-template:visit',
      '/institution/reports/templates/:templateId:visit',

      '/institution/my-activities:visit',
      '/institution/my-activities/:activityId/sessions/:visit',
      '/institution/my-activities/:activityId/sessions/create:visit',
      '/institution/my-activities/:activityId/sessions/:sessionId:visit',
      '/institution/my-activities/:activityId/attendees/:visit',
      '/institution/activities/activity/:activityId:visit',

      '/institution/manage/cases:visit',
      '/institution/manage/cases/:caseId:visit',
      '/institution/manage/cases/case-management:visit',
      '/institution/manage/cases/appointments:visit',
      '/institution/manage/cases/medication-queue:visit',

      '/institution/my-forms:visit',
      '/institution/my-forms/:id/:date/capture:visit',
      '/institution/my-forms/:id/submissions:visit',
      '/institution/my-forms/:id/submissions/:submissionId:visit',
      '/institution/my-forms/:id/submissions/:submissionId/calculate:visit',
      '/institution/my-forms/:id/submissions/calculate/:monitoringFormId/:periodNumber:visit',

      '/institution/my-forms/:id/submissions/submit:visit',
    ],
  },
  PREMIUM: {
    static: [
      ...freeExplorerRoutes,
      '/institution/reports:visit',
      '/institution/reports/requirements:visit',
      //  '/institution/reports/create:visit',
      '/institution/reports/create-link:visit',
      '/institution/reports/create-report:visit',
      '/institution/reports/:reportId:visit',
      '/institution/reports/templates:visit',
      '/institution/reports/create-template:visit',
      '/institution/reports/templates/:templateId:visit',

      '/institution/my-activities:visit',
      '/institution/my-activities/:activityId/sessions/:visit',
      '/institution/my-activities/:activityId/sessions/create:visit',
      '/institution/my-activities/:activityId/sessions/:sessionId:visit',
      '/institution/my-activities/:activityId/attendees/:visit',
      '/institution/activities/activity/:activityId:visit',

      '/institution/manage/cases:visit',
      '/institution/manage/cases/:caseId:visit',
      '/institution/manage/cases/case-management:visit',
      '/institution/manage/cases/appointments:visit',
      '/institution/manage/cases/medication-queue:visit',

      '/institution/my-forms:visit',
      '/institution/my-forms/:id/:date/capture:visit',
      '/institution/my-forms/:id/submissions:visit',
      '/institution/my-forms/:id/submissions/:submissionId:visit',
      '/institution/my-forms/:id/submissions/:submissionId/calculate:visit',
      '/institution/my-forms/:id/submissions/calculate/:monitoringFormId/:periodNumber:visit',
      '/institution/my-forms/:id/submissions/submit:visit',
    ],
  },
  ENTERPRISE: {
    static: [
      ...freeExplorerRoutes,
      '/institution/reports:visit',
      '/institution/reports/requirements:visit',
      //  '/institution/reports/create:visit',
      '/institution/reports/create-link:visit',
      '/institution/reports/create-report:visit',
      '/institution/reports/:reportId:visit',
      '/institution/reports/templates:visit',
      '/institution/reports/create-template:visit',
      '/institution/reports/templates/:templateId:visit',

      '/institution/my-activities:visit',
      '/institution/my-activities/:activityId/sessions/:visit',
      '/institution/my-activities/:activityId/sessions/create:visit',
      '/institution/my-activities/:activityId/sessions/:sessionId:visit',
      '/institution/my-activities/:activityId/attendees/:visit',
      '/institution/activities/activity/:activityId:visit',

      '/institution/manage/cases:visit',
      '/institution/manage/cases/:caseId:visit',
      '/institution/manage/cases/case-management:visit',
      '/institution/manage/cases/appointments:visit',
      '/institution/manage/cases/medication-queue:visit',

      '/institution/my-forms:visit',
      '/institution/my-forms/:id/:date/capture:visit',
      '/institution/my-forms/:id/submissions:visit',
      '/institution/my-forms/:id/submissions/:submissionId:visit',
      '/institution/my-forms/:id/submissions/:submissionId/calculate:visit',
      '/institution/my-forms/:id/submissions/calculate/:monitoringFormId/:periodNumber:visit',
      '/institution/my-forms/:id/submissions/submit:visit',
    ],
  },
  BUSINESS: {
    static: [
      ...freeExplorerRoutes,
      '/institution/reports:visit',
      '/institution/reports/requirements:visit',
      //  '/institution/reports/create:visit',
      '/institution/reports/create-link:visit',
      '/institution/reports/create-report:visit',
      '/institution/reports/:reportId:visit',
      '/institution/reports/templates:visit',
      '/institution/reports/create-template:visit',
      '/institution/reports/templates/:templateId:visit',

      '/institution/my-activities:visit',
      '/institution/my-activities/:activityId/sessions/:visit',
      '/institution/my-activities/:activityId/sessions/create:visit',
      '/institution/my-activities/:activityId/sessions/:sessionId:visit',
      '/institution/my-activities/:activityId/attendees/:visit',
      '/institution/activities/activity/:activityId:visit',

      '/institution/manage/cases:visit',
      '/institution/manage/cases/:caseId:visit',
      '/institution/manage/cases/case-management:visit',
      '/institution/manage/cases/appointments:visit',
      '/institution/manage/cases/medication-queue:visit',

      '/institution/my-forms:visit',
      '/institution/my-forms/:id/:date/capture:visit',
      '/institution/my-forms/:id/submissions:visit',
      '/institution/my-forms/:id/submissions/:submissionId:visit',
      '/institution/my-forms/:id/submissions/:submissionId/calculate:visit',
      '/institution/my-forms/:id/submissions/calculate/:monitoringFormId/:periodNumber:visit',
      '/institution/my-forms/:id/submissions/submit:visit',
    ],
  },
};

export const INSTITUTION_GUEST_PLANS = {
  FREE_VIEWER: {
    static: [
      '/:visit',
      '/admin/sign-in:visit',
      '/funder/sign-in:visit',
      '/institution/sign-in:visit',
      '/service-provider/sign-in:visit',
      '/forgot-password:visit',

      '/institution:visit',
      '/institution/my-profile:visit',
      '/institution/notifications:visit',
      '/institution/insights:visit',
      '/institution/insights/:insightType/:insightId:visit',
    ],
  },
  FREE_EXPLORER: {
    static: [
      '/:visit',
      '/admin/sign-in:visit',
      '/funder/sign-in:visit',
      '/institution/sign-in:visit',
      '/service-provider/sign-in:visit',
      '/forgot-password:visit',

      '/institution:visit',
      '/institution/my-profile:visit',
      '/institution/notifications:visit',
      '/institution/insights:visit',
      '/institution/insights/:insightType/:insightId:visit',
    ],
  },
  STANDARD: {
    static: fullGuestRoutes,
  },
  PREMIUM: {
    static: fullGuestRoutes,
  },
  ENTERPRISE: {
    static: fullGuestRoutes,
  },
  BUSINESS: {
    static: fullGuestRoutes,
  },
};
